import { AttributeOption } from '@mark43/cad-api';
import { Caution, Flex, Text } from '@cad-arc';
import { CommonSize, getAttributePriority } from '../helpers/utils';

export function LocationRiskPriority({
    eventPriority,
    riskLevel,
    size,
}: {
    eventPriority?: AttributeOption;
    riskLevel?: AttributeOption;
    size?: CommonSize;
}) {
    const style = { padding: '10px', marginTop: '2px' };

    return (
        <Flex columnGap={10}>
            {eventPriority?.label && (
                <Caution priority={getAttributePriority(eventPriority)} style={style}>
                    <Text fontSize={size}>{eventPriority.label}</Text>
                </Caution>
            )}
            {riskLevel?.label && (
                <Caution priority={getAttributePriority(riskLevel)} style={style}>
                    <Text fontSize={size}>{riskLevel.label}</Text>
                </Caution>
            )}
        </Flex>
    );
}
